/**
 * next/navigation shim — maps the Next App Router navigation hooks the synced
 * prod leaves use (NavLink, SettingsNavButton, ClientProfileSwitcher, …) onto
 * react-router equivalents, so active-state highlighting and programmatic
 * navigation work in the Vite SPA.
 */
import { useLocation, useNavigate } from "react-router-dom";

export function usePathname(): string {
  return useLocation().pathname;
}

export function useSearchParams(): URLSearchParams {
  return new URLSearchParams(useLocation().search);
}

export function useRouter() {
  const navigate = useNavigate();
  return {
    push: (href: string) => navigate(href),
    replace: (href: string) => navigate(href, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    refresh: () => {},
    prefetch: () => {},
  };
}

/** Server-only in Next; in the demo it's a hard navigation (rarely hit). */
export function redirect(href: string): void {
  if (typeof window !== "undefined") window.location.href = href;
}
